<template>
    <div v-if="!$_.isEmpty(actions)" class="item-controls" @click.stop="handleClick">
        <span class="controls-icon">
            <icon-base width="4" height="16" viewBox="0 0 4 16"><icon-controls/></icon-base>
        </span>
        <ul class="controls-dropdown" v-show="visibleControls===_uid">
            <controls-dropdown-item v-for="(action,index) in actions" :action="action" :key="index"
                                    :item-id="itemId"></controls-dropdown-item>
        </ul>
    </div>

</template>

<script>
    import ControlsDropdownItem from "./ControlsDropdownItem";
    import IconBase from "../common/IconBase";
    import IconControls from "../common/icons/IconControls";

    export default {
        name: 'controls-dropdown',
        components: {
            IconBase,
            IconControls,
            ControlsDropdownItem},
        props: {
            visibleControls: Number,
            itemId: Number,
            actions: {
                type: Array,
                required: true
            }
        },
        computed: {
            showControls() {
                return this.visibleControlsId === this._uid;
            }
        },
        updated() {
            //console.log('updated');
        },
        methods: {
            handleClick() {
                //console.log('click');
                this.$emit('click',this._uid)
            }
        }

    }
</script>

<style scoped>

</style>
